module.exports = __webpack_public_path__ + "img/onis-showcase-anim.10ebaab1.gif";